import config from '@/config/appConfig';
import { useAuthStore } from '@/store/auth';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_DEVPROD === 'DEV' ? config.pulseServiceBaseUrlDev : config.pulseServiceBaseUrl,
  headers: {
    accept: 'application/json'
  }
});

instance.interceptors.request.use((requestConfig) => {
  const authStore = useAuthStore();
  const token = authStore.accessToken;
  if (token) {
    requestConfig.headers.Authorization = `Bearer ${token}`;
  }
  return requestConfig;
});

export default instance;
